import { StyledPageNotFound } from './PageNotFound.style';
import PageNotFoundIllustration from '../../images/page-not-found.svg';

export function PageNotFound() {
  return (
    <StyledPageNotFound data-cy='linui-404-page'>
      <div>
        <img src={PageNotFoundIllustration} alt='page not found illustration' />
        <h1>OOPS!</h1>
        <p>
          This page could not be found
          <br /> Try refreshing your page. if that doesn&#39;t work contact
          support.
        </p>
      </div>
    </StyledPageNotFound>
  );
}
